module.exports = __webpack_public_path__ + "852b7dd73dfcf4ef517b99f99b3ee9ac.svg";